const borderWidths = {
  small: '1px',
  large: '6px',
};

export default borderWidths;
